import { IonIcon } from '@ionic/react';
import classNames from 'classnames';
import { arrowBackOutline } from 'ionicons/icons';
import React from 'react';

import { webCampaign } from '@/modules/webCampaign.ts';

import { useOnboarding } from '../../context';
import { OnboardingParamsTool } from '../../utils/paramsTool';

import './Navigation.scss';

// TODO remove steps and wizard from props
interface HeadlineOptions {
  dotColor?: 'white';
  isRenderBackButton?: boolean;
  onBack?: () => void;
  showSkip?: boolean;
}

const themeClassMap: Record<string, string> = {
  default: '',
  domination: 'onboarding-navigation__dot--domination',
  'purple-gradient': 'onboarding-navigation__dot--purple-gradient',
};

const navigationClassMap: Record<string, string> = {
  default: '',
  domination: '',
  'purple-gradient': 'onboarding-navigation--purple-gradient',
};

export const OnboardingNavigation: React.FC<HeadlineOptions> = ({
  dotColor,
  isRenderBackButton,
  onBack,
  showSkip = false,
}) => {
  const { steps, wizard } = useOnboarding();
  const stepIndex = wizard.stepIndex();

  const actualTheme = webCampaign.getStaticTheme() || 'default';

  const getDotClassList = (dotIndex: number): string =>
    classNames('onboarding-navigation__dot', {
      'onboarding-navigation__dot--active': stepIndex === dotIndex,
      [themeClassMap[actualTheme]]:
        stepIndex === dotIndex && actualTheme !== 'default',
    });

  const handleBack = (): void => {
    if (onBack) {
      onBack();
      return;
    }

    const prevStep = Object.keys(steps)[stepIndex - 1];
    if (prevStep) {
      OnboardingParamsTool.setParam('step', prevStep);
      wizard.goToStep(prevStep);
    }
  };

  const needToRenderBackButton =
    typeof isRenderBackButton === 'undefined'
      ? stepIndex !== 0 && stepIndex < Object.keys(steps).length - 2
      : isRenderBackButton;

  return (
    <div
      className={classNames('onboarding-navigation', {
        'onboarding-navigation--white': dotColor === 'white',
        [navigationClassMap[actualTheme]]: actualTheme !== 'default',
      })}
    >
      <div className="onboarding-navigation__container">
        {needToRenderBackButton && (
          <button
            className="onboarding-navigation__back-button"
            onClick={handleBack}
            type="button"
          >
            <IonIcon icon={arrowBackOutline} />
          </button>
        )}
        <div className="onboarding-navigation__dots">
          {Object.keys(steps).map((stepName, i) => (
            <div key={stepName} className={getDotClassList(i)} />
          ))}
        </div>
        {showSkip && (
          <button
            className="onboarding-navigation__skip-button"
            onClick={() => wizard.nextStep()}
            type="button"
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
};
